import { render, staticRenderFns } from "./OriginalsSection.vue?vue&type=template&id=62b99b57&"
import script from "./OriginalsSection.vue?vue&type=script&lang=js&"
export * from "./OriginalsSection.vue?vue&type=script&lang=js&"
import style0 from "./OriginalsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports